import { render, staticRenderFns } from "./editRecommendation.vue?vue&type=template&id=d083db02&scoped=true"
import script from "./editRecommendation.vue?vue&type=script&lang=js"
export * from "./editRecommendation.vue?vue&type=script&lang=js"
import style0 from "./editRecommendation.vue?vue&type=style&index=0&id=d083db02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d083db02",
  null
  
)

export default component.exports